import { useSelector } from 'react-redux'

import { isNil } from 'helpers/lodash'
import { getInfoFromIdentity } from 'helpers/twilio'
import { _dominantSpeaker } from 'store/selectors/Room'

import useParticipants from '../useParticipants/useParticipants'

export default function useDominantSpeaker() {
    const dominantSpeaker = useSelector(_dominantSpeaker)

    const { allParticipants } = useParticipants()

    if (isNil(dominantSpeaker)) return null

    const dominantSpeakerParticipant = allParticipants.find(
        participant =>
            getInfoFromIdentity(participant.identity).id === dominantSpeaker
    )

    return dominantSpeakerParticipant
}
